import Vue from 'vue'
const bus = new Vue()
bus.data = {
  type: '开发版',
  SSO_timeID:''
}
export default bus